<template>
    <div>
        <div class="dropdown">
            <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Manage
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <button v-if="data.active" class="dropdown-item" @click="click(data)">
                    Deactivate
                </button>
                <button v-else class="dropdown-item" @click="click(data)">
                    Reactivate
                </button>
                <button class="dropdown-item" @click="resetPassword">Reset Password</button>
                <!-- In the parent component where you use the button -->
                <button
                    v-if="data.active"
                    class="dropdown-item"
                    @click="openManageTrialModal(data)"
                    :id="'openManageTrialModalBtn_' + generateUniqueId(data.user_name)"
                >
                    Manage Trial
                </button>
            </div>
            <button v-if="data.group_access ==='Base' || data.group_access === 'Trial'" class="btn btn-warning btn-sm text-dark" @click="click(data, 'notify')" :click="$emit('increment-btn', 1)" data-bs-toggle="tooltip" data-bs-placement="right" title="Notify">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bell-fill" viewBox="0 0 16 16">
                    <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z"/>
                </svg>
            </button>
        </div>
        <ManageGroupAccessModal :existingGroupAccessArray="existingGroupAccessArray"/>
        <ManageGroupAccessModal ref="manageDurationModalRef" />
    </div>
</template>

<script>

import axios from "axios";
import ManageGroupAccessModal from "./ManageGroupAccessModal";

export default {
    components: {
        ManageGroupAccessModal
    },
    props: {
        data: {},
        name: {},
        click: {
            type: Function,
            default: () => {},
        },
        userEmail: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            existingGroupAccessArray: [],
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            showManageGroupAccessModal: false,
            trialGroupAccessList: [
                { id: 'subappaccess', name: 'Everything' },
                { id: 'suballusaccess', name: 'Everything US (All Newsletters & US Database)' },
                { id: 'subappentiredb', name: 'Entire Database' },
                { id: 'subappafricadb', name: 'Africa & Latin America Database' },
                { id: 'subappasiadb', name: 'Asia Database' },
                { id: 'subappusdb', name: 'US Database' },
                { id: 'subappcredit', name: 'Credit Newsletters (VCWI, UAFRS)' },
                { id: 'subappequity', name: 'Equity Newsletters (VEII, VEIH, CLL, UAFRS, TSIL)' },
                { id: 'submacronewsletters', name: 'Market Phase Cycle' },
                { id: 'suballnewsletters', name: 'All Valens Research Newsletters' },
                { id: 'subappeuropedb', name: 'Europe Database' },
                { id: 'Trial', name: 'Trial' },
                { id: 'subfaalphapulse', name: 'Fa Alpha Pulse' },
            ],
        };
    },
    methods: {

        async openManageTrialModal(data) {
            const uniqueId = this.generateUniqueId(data.user_name);
            this.$refs.manageDurationModalRef.openModal(uniqueId);
        },

        generateUniqueId(user_name) {
            return user_name;
        },
        async fetchUserData(data) {
            try {
                const response = await axios.get(`/api/user-trial-account/${data.user_name}`);
                const groupAccessData = response.data;

                if (!groupAccessData) {
                    console.log('No data found for user:', data.user_name);
                    return [{
                        email: data.user_name,
                        name: null,
                        formattedDate: null,
                        isEditing: false,
                    }];
                }

                const matchingTrialGroup = this.trialGroupAccessList.find(trialGroup => trialGroup.id === groupAccessData.group_access);
                const dateParts = groupAccessData.expiration_date.split(' ');
                const formattedDate = dateParts[0];

                return [{
                    email: groupAccessData.email,
                    name: matchingTrialGroup ? matchingTrialGroup.name : null,
                    formattedDate: formattedDate,
                    isEditing: false,
                }];
            } catch (error) {
                console.error('Error fetching user data:', error);
                return [{
                    email: data.user_name,
                    name: null,
                    formattedDate: null,
                    isEditing: false,
                }];
            }
        },


        resetPassword() {
            let email = this.data.user_name;

            let confirmation = confirm(`Reset password for ${email}?`);
            if (!confirmation) return false;

            axios.post('/api/user-reset-password', {
                email,
                __token: this.csrf,
            })
                .then((response) => {
                    let data = response.data;
                    let msg = {
                        header: 'Reset Successfully',
                        message: `The new password for ${email} is: <b>${data.new_password}</b>`,
                        reload: false,
                    };
                    this.click('alert', msg);
                }, (error) => {
                    console.log(error);
                });
        },
    },
};
</script>
